export const DATAENTRY_REDIRECT_VETVIEW = 'DATAENTRY_REDIRECT_VETVIEW';
